export const projectName = 'SitoBank';

const SITOBANK_DOMAIN = 'sitobank.com';
const PAYVELO_DOMAIN = 'payvelo.net';

function isPayveloDomain() {
	return getDomain(location.hostname) === PAYVELO_DOMAIN;
}

export function getApiDomain() {
	let hostname = `${getDomain(location.hostname)}`;
	let protocol = location.protocol;
	let api = 'api';
	switch (process.env.NODE_ENV) {
		case 'dev':
		// case 'production':
		// 	api = 'manager-api.sito.dev';
		// 	hostname = 'seafintech.com';
		// 	protocol = 'https:';
		// 	break;
		case 'development':
			api = 'manager-api.sito.dev';
			hostname = 'seafintech.com';
			protocol = 'https:';
			break;
	}
	if (window.location.href.includes('test')) {
		// hostname = 'test.payment-dev.com';
		// protocol = 'http:';
		api = 'manager-api.sito.test';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('sitobanksandbox')) {
		// hostname = 'test.payment-dev.com';
		// protocol = 'http:';
		api = 'mexico-manager-api.sito.test';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('dev')) {
		// hostname = 'test.payment-dev.com';
		// protocol = 'http:';
		api = 'manager-api.sito.dev';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('uat')) {
		api = 'uat-sito-manager-api';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	if (isPayveloDomain()) {
		api = 'api';
		hostname = PAYVELO_DOMAIN;
		protocol = 'https:';
	}
	let domain = `${protocol}//${api}.${hostname}`;
	return domain;
}
export function getMerchantApiDomain() {
	let hostname = `merchant.${getDomain(location.hostname)}`;
	let protocol = location.protocol;
	let api = 'api';
	switch (process.env.NODE_ENV) {
		case 'dev':
		// case 'production':
		// 	api = 'dev-sito-merchant-api';
		// 	hostname = 'seafintech.com';
		// 	protocol = 'https:';
		// 	break;
		case 'development':
			api = 'merchant-api.sito.dev';
			hostname = 'seafintech.com';
			protocol = 'https:';
			break;
	}
	if (window.location.href.includes('test')) {
		api = 'merchant-api.sito.test';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('dev')) {
		// hostname = 'test.payment-dev.com';
		// protocol = 'http:';
		api = 'merchant-api.sito.dev';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('sitobanksandbox')) {
		// hostname = 'test.payment-dev.com';
		// protocol = 'http:';
		api = 'mexico-merchant-api.sito.test';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	// if (window.location.href.includes('sitobank.com')) {
	// 	api = 'api';
	// }
	if (isPayveloDomain()) {
		api = 'api';
		hostname = `merchant.${PAYVELO_DOMAIN}`;
		protocol = 'https:';
	}
	let domain = `${protocol}//${api}.${hostname}`;
	// let domain = `https://dev-merchant-api.payment-dev.com`;
	return domain;
}
export function getAgentApiDomain() {
	let hostname = `agent.${getDomain(location.hostname)}`;
	let protocol = location.protocol;
	let api = 'api';
	switch (process.env.NODE_ENV) {
		case 'dev':
		// case 'production':
		// 	api = 'dev-sito-agent-api';
		// 	hostname = 'seafintech.com';
		// 	protocol = 'https:';
		// 	break;
		case 'development':
			api = 'agent-api.sito.dev';
			hostname = 'seafintech.com';
			protocol = 'https:';
			break;
	}
	if (window.location.href.includes('test')) {
		// api = 'test-agent-api';
		// hostname = 'payment-dev.com';
		// protocol = 'https:';
		api = 'agent-api.sito.test';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('dev')) {
		// hostname = 'test.payment-dev.com';
		// protocol = 'http:';
		api = 'agent-api.sito.dev';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('sitobanksandbox')) {
		// hostname = 'test.payment-dev.com';
		// protocol = 'http:';
		api = 'mexico-agent-api.sito.test';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('sitobank.com')) {
		api = 'api';
	}
	if (isPayveloDomain()) {
		api = 'api';
		hostname = `agent.${PAYVELO_DOMAIN}`;
		protocol = 'https:';
	}
	let domain = `${protocol}//${api}.${hostname}`;
	// let domain = `https://dev-agent-api.payment-dev.com`;
	return domain;
}

export function getWssDomain() {
	let hostname = getDomain(location.hostname);
	let protocol = 'wss:';
	let subdomainName = 'api';
	if (hostname === SITOBANK_DOMAIN) {
		subdomainName = 'api';
	} else if (hostname === PAYVELO_DOMAIN) {
		subdomainName = 'api';
		hostname = PAYVELO_DOMAIN;
	} else if (hostname === 'payup.work') {
		subdomainName = 'api';
	} else {
		subdomainName = 'manager-api.sito.dev';
		hostname = 'seafintech.com';
	}
	if (window.location.href.includes('test')) {
		subdomainName = 'manager-api.sito.test';
		protocol = 'wss:';
	}
	if (window.location.href.includes('sitobanksandbox')) {
		subdomainName = 'manager-api.sito.test';
		protocol = 'wss:';
	}
	if (window.location.href.includes('uat')) {
		subdomainName = 'uat-sito-manager-api';
		protocol = 'wss:';
	}
	// switch (process.env.NODE_ENV) {
	//   case 'dev':
	//   case 'development':
	//     hostname = 'payment-dev.com';
	//     subdomainName = 'api';
	//     break;
	//   case 'production':
	//     hostname = 'payment-dev.com';
	//     subdomainName = 'api';
	//     break;
	// }
	let domain = `${protocol}//${subdomainName}.${hostname}`;
	return domain;
}
export function getMerchantWssDomain() {
	let hostname = getDomain(location.hostname);
	let protocol = 'wss:';
	let subdomainName = 'merchant-api.sito.dev';
	if (hostname === SITOBANK_DOMAIN) {
		subdomainName = 'api';
		hostname = `merchant.${SITOBANK_DOMAIN}`;
	} else if (hostname === PAYVELO_DOMAIN) {
		subdomainName = 'api';
		hostname = `merchant.${PAYVELO_DOMAIN}`;
	} else if (hostname === 'payup.work') {
		subdomainName = 'api';
		hostname = `merchant.${hostname}`;
	} else {
		hostname = 'seafintech.com';
	}
	if (window.location.href.includes('test')) {
		subdomainName = 'merchant-api.sito.test';
		protocol = 'wss:';
	}
	if (window.location.href.includes('sitobanksandbox')) {
		subdomainName = 'merchant-api.sito.test';
		protocol = 'wss:';
	}
	if (window.location.href.includes('uat')) {
		subdomainName = 'uat-sito-merchant-api';
		protocol = 'wss:';
	}
	// switch (process.env.NODE_ENV) {
	//   case 'dev':
	//   case 'development':
	//     hostname = 'payment-dev.com';
	//     subdomainName = 'api';
	//     break;
	//   case 'production':
	//     hostname = 'payment-dev.com';
	//     subdomainName = 'api';
	//     break;
	// }
	let domain = `${protocol}//${subdomainName}.${hostname}`;
	return domain;
}
export function getAgentWssDomain() {
	let hostname = getDomain(location.hostname);
	let protocol = 'wss:';
	let subdomainName = 'agent-api.sito.dev';
	if (hostname === SITOBANK_DOMAIN) {
		subdomainName = 'api';
		hostname = `agent.${SITOBANK_DOMAIN}`;
	} else if (hostname === PAYVELO_DOMAIN) {
		subdomainName = 'api';
		hostname = `agent.${PAYVELO_DOMAIN}`;
	} else if (hostname === 'payup.work') {
		subdomainName = 'api';
		hostname = `agent.${hostname}`;
	} else {
		hostname = 'seafintech.com';
	}
	if (window.location.href.includes('test')) {
		subdomainName = 'agent-api.sito.test';
		protocol = 'wss:';
	}
	if (window.location.href.includes('test')) {
		subdomainName = 'agent-api.sito.test';
		protocol = 'wss:';
	}
	if (window.location.href.includes('sitobanksandbox')) {
		subdomainName = 'agent-api.sito.test';
		protocol = 'wss:';
	}
	if (window.location.href.includes('uat')) {
		subdomainName = 'uat-sito-agent-api';
		protocol = 'wss:';
	}
	// switch (process.env.NODE_ENV) {
	//   case 'dev':
	//   case 'development':
	//     hostname = 'payment-dev.com';
	//     subdomainName = 'api';
	//     break;
	//   case 'production':
	//     hostname = 'payment-dev.com';
	//     subdomainName = 'api';
	//     break;
	// }
	let domain = `${protocol}//${subdomainName}.${hostname}`;
	return domain;
}

export function getExqueryDomain() {
	let hostname = getDomain(location.hostname);
	let protocol = location.protocol;
	let subdomainName = 'v2.exq';
	switch (process.env.NODE_ENV) {
		case 'dev':
		case 'development':
			hostname = 'payment-dev.com';
			protocol = 'https:';
			break;
	}
	if (window.location.href.includes('test')) {
		subdomainName = 'exquery.sito.test';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('dev')) {
		subdomainName = 'exquery.sito.dev';
		hostname = 'seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('uat')) {
		subdomainName = 'uat-sito-exquery';
		protocol = 'https:';
	}
	if (isPayveloDomain()) {
		subdomainName = 'v2.exq';
		hostname = PAYVELO_DOMAIN;
		protocol = 'https:';
	}
	let domain = `${protocol}//${subdomainName}.${hostname}`;
	return domain;
}

function getDomain(hostname) {
	return hostname.substring(hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1);
}

export function getOrigin() {
	let hostname = getDomain(location.hostname);
	let protocol = location.protocol;
	let manager = 'manager';
	switch (process.env.NODE_ENV) {
		case 'dev':
			hostname = 'sitobank.com';
		case 'development':
			hostname = 'manager.sito.dev.seafintech.com';
			protocol = 'https:';
			break;
	}
	if (window.location.href.includes('test')) {
		hostname = 'manager.sito.test.seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('dev')) {
		hostname = 'manager.sito.dev.seafintech.com';
		protocol = 'https:';
	}
	if (window.location.href.includes('uat')) {
		hostname = 'uat-sito-manager.seafintech.com';
		protocol = 'https:';
	}
	if (isPayveloDomain()) {
		hostname = `manager.${PAYVELO_DOMAIN}`;
		protocol = 'https:';
	}
	let domain = `${protocol}//${hostname}`;
	return domain;
}
export function getMerchantOrigin() {
	let hostname = `merchant.${getDomain(location.hostname)}`;
	let protocol = location.protocol;
	let merchant = 'merchant';
	switch (process.env.NODE_ENV) {
		case 'dev':
			hostname = 'merchant.sitobank.com';
		case 'development':
			hostname = 'merchant.sito.dev.seafintech.com';
			protocol = 'https:';
			break;
	}
	if (window.location.href.includes('test')) {
		// hostname = 'test-merchant.seafintech.com';
		// protocol = 'https:';
		hostname = 'merchant.sito.test.seafintech.com';
		protocol = 'https:';
		// merchant = 'payment-test-merchant';
	}
	if (window.location.href.includes('dev')) {
		hostname = 'merchant.sito.dev.seafintech.com';
		protocol = 'https:';
	}
	if (isPayveloDomain()) {
		hostname = `merchant.${PAYVELO_DOMAIN}`;
		protocol = 'https:';
	}
	let domain = `${protocol}//${hostname}`;
	return domain;
}
export function getAgentOrigin() {
	let hostname = `agent.${getDomain(location.hostname)}`;
	let protocol = location.protocol;
	let agent = 'agent';
	switch (process.env.NODE_ENV) {
		case 'dev':
			hostname = 'agent.sitobank.com';
		case 'development':
			hostname = 'agent.sito.dev.seafintech.com';
			protocol = 'https:';

			break;
	}
	if (window.location.href.includes('test')) {
		// hostname = 'test-agent.seafintech.com';
		// protocol = 'https:';
		hostname = 'agent.sito.test.seafintech.com';
		protocol = 'https:';
		// agent = 'payment-test-agent';
	}
	if (window.location.href.includes('dev')) {
		hostname = 'agent.sito.dev.seafintech.com';
		protocol = 'https:';
	}
	if (isPayveloDomain()) {
		hostname = `agent.${PAYVELO_DOMAIN}`;
		protocol = 'https:';
	}
	let domain = `${protocol}//${hostname}`;
	return domain;
}
export function getComplaintsOrigin() {
	let hostname = `complaint.${SITOBANK_DOMAIN}`;
	let protocol = location.protocol;
	switch (process.env.NODE_ENV) {
		case 'dev':
			hostname = 'sitobank.com';
		case 'development':
			hostname = 'dev-sito-complaint.seafintech.com';
			protocol = 'https:';
			break;
	}
	if (window.location.href.includes('test')) {
		hostname = 'test-sito-complaint.seafintech.com';
		protocol = 'https:';
	}
	if (isPayveloDomain()) {
		hostname = `complaint.${PAYVELO_DOMAIN}`;
		protocol = 'https:';
	}
	let domain = `${protocol}//${hostname}`;
	return domain;
}
